import type { ITrainingOffer } from "@bbj-types/offer";
import type { ObjectId } from "@bbj-types/utils";
import type { TrainingOfferModality } from "@root/utils/enums/offer";
import type { IDateRange } from "@styleguide";
import { useCallback } from "react";
import { axios } from "../axios";

export interface IGetTrainingOffersByCandidate {
  data: ITrainingOffer[];
  offersLimit: number;
  totalLimit: number;
  skip: number;
  count: number;
  total: number;
  metadata?: {
    filtersHash?: string;
  };
}

export interface IGetTrainingOffersByCandidateParams {
  offersLimit: number;
  totalLimit: number;
  skip: number;
  search?: string;
  trainingStartDate?: IDateRange;
  trainingEndDate?: IDateRange;
  searchRadius?: number;
  places?: string[];
  filtersHash?: string;
  provider?: string;
  modalities?: TrainingOfferModality[];
  trainingDuration?: [number, number];
  hasContact?: boolean;
  isExpired?: boolean;
}

export const useGetTrainingOffersByCandidate = () => {
  const [state, execute, cancel] = axios<IGetTrainingOffersByCandidate>(
    {
      method: "get",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (candidateId: ObjectId, params: IGetTrainingOffersByCandidateParams) => {
      return execute({
        url: `/offers/training/search/candidate/${candidateId}`,
        params,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
